import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
      image: {
     
      },
      black1: {
        fontFamily: 'Poppins',
        fontSize: 18,
        textAlign: 'center',
        fontStyle: 'bold',
        fontWeight: 'fontWeightBold',
        color: 'rgba(51, 51, 51, 1)',
      },
      black2: {
        fontFamily: 'Poppins',
        fontSize: 18,
        textAlign: 'center',
        fontStyle: 'bold',
        fontWeight: 'fontWeightBold',
        color: 'blue',
      }
}))